import React, { RefObject, useEffect, useState } from 'react'

import styles from '../Documents.module.css'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../redux/store'
import {
  Contract,
  fetchContracts,
  setCurrentContract,
  setIsVisibleDeleteModalContract,
  setIsVisibleModalContract,
} from '../../../redux/reducers/documents/contracts'
import { contractsSelector } from '../../../redux/selectors/documents/contracts-selector'
import { useOutsideClick } from '../../../hooks/useOutsideClick'
import EditButton from '../../../components/buttons/actions-button/EditButton'
import DeleteButton from '../../../components/buttons/actions-button/DeleteButton'
import { formatDate, isLessThanAMonth } from '../../../utils/date'
import {
  fetchClient,
  fetchClients,
  setIsVisibleModalClient,
} from '../../../redux/reducers/clients'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { registerLocale } from 'react-datepicker'
import ru from 'date-fns/locale/ru'

import { default as Select } from 'react-select'
import {
  getAmount,
  getContractRemainingAmount,
  getItemCurrency,
} from '../../../utils/getAmount'

registerLocale('ru', ru)
interface DropDownProps {
  value: { id: string | number; name: string }
  items: Array<{ id: string | number; name: string }>
  refDropdown: RefObject<HTMLDivElement>
  handleButtonClick: () => void
  isSelectMenu: boolean
  handleChangeItem: (item: { id: string | number; name: string }) => void
  isVisibleAddBlock?: boolean
}

const COUNTRIES = [
  { id: '', name: 'Все страны' },
  { id: 'BY', name: 'Беларусь' },
  { id: 'RU', name: 'Россия' },
]

const STATUSES = [
  { id: '', name: 'Все статусы' },
  { id: 1, name: 'Активен' },
  { id: 0, name: 'Закрыт' },
]

const DropDown: React.FC<DropDownProps> = (props) => {
  const {
    value,
    items,
    refDropdown,
    handleButtonClick,
    isSelectMenu,
    handleChangeItem,
    isVisibleAddBlock,
  } = props
  return (
    <div
      className={
        isVisibleAddBlock
          ? 'd-none d-sm-block col-sm-6 col-md-6 col-lg-3 col-xl-3'
          : 'col-6 col-sm-6 col-md-6 col-lg-3 col-xl-3'
      }
    >
      <div
        ref={refDropdown}
        className={`${styles.dropdown} d-block`}
        style={{ textAlign: 'left' }}
      >
        <div
          onClick={handleButtonClick}
          className={classNames(
            styles.btn,
            styles.btnSmall,
            styles.btnInput,
            styles.btnDropdown,
            isSelectMenu && styles.btnDropdownActive
          )}
        >
          {value.name}
        </div>
        <div
          className={classNames(
            styles.dropdownContent,
            styles.dropdownSelect,
            isSelectMenu && styles.dropdownContentActive
          )}
        >
          {items.map((item) => (
            <div onClick={() => handleChangeItem(item)} key={item.id}>
              {item.name}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

const Filter = ({ setUpdatedContracts }: { setUpdatedContracts: any }) => {
  const [startDate, setStartDate] = useState<Date | undefined>(undefined)
  const [endDate, setEndDate] = useState<Date | undefined>(undefined)
  const [isOpen, setIsOpen] = useState(false)
  const [isFilterFixed, setIsFilterFixed] = useState(false)

  const { contracts } = useSelector(contractsSelector)

  const handleChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates
    setStartDate(start || undefined)
    setEndDate(end || undefined)
  }

  const handleClick = () => {
    setIsOpen(!isOpen)
  }

  //COUNTRY
  const [country, setCountry] = useState<{ id: string | number; name: string }>(
    COUNTRIES[0]
  )
  const [isSelectMenuCountry, setIsSelectMenuCountry] = useState(false)
  const refCountry = useOutsideClick(() => {
    setIsSelectMenuCountry(false)
  })
  const handleSelectChangeCountry = (country: {
    id: string | number
    name: string
  }) => {
    setCountry(country)

    setIsSelectMenuCountry(false)
  }
  const handleButtonClickCountry = () => {
    setIsSelectMenuCountry((prev) => !prev)
  }

  //STATUS
  const [status, setStatus] = useState<{ id: string | number; name: string }>(
    STATUSES[1]
  )
  const [isSelectMenuStatus, setIsSelectMenuStatus] = useState(false)

  const refStatus = useOutsideClick(() => {
    setIsSelectMenuStatus(false)
  })
  const handleSelectChangeStatus = (status: {
    id: string | number
    name: string
  }) => {
    setStatus(status)

    setIsSelectMenuStatus(false)
  }
  const handleButtonClickStatus = () => {
    setIsSelectMenuStatus((prev) => !prev)
  }

  const redData = useOutsideClick(() => {
    setIsOpen(false)
  })

  interface ClientOption {
    value: string | number
    label: string
  }
  interface Client {
    id: string | number
    name: string
  }

  const getClients = contracts.map((item) => ({
    id: item.client.id,
    name: item.client.name,
  }))

  // Удаляем дубликаты клиентов
  const uniqueClients = Array.from(
    new Map(getClients.map((item) => [item.id, item])).values()
  )

  const clientOptions = [
    { value: '', label: 'Все клиенты' },
    ...uniqueClients
      .map((client: Client) => ({
        value: client.id,
        label: client.name || 'Без имени',
      }))
      .sort((a, b) => a.label.localeCompare(b.label)),
  ]

  const [clients, setClients] = useState<{ id: string | number; name: string }>(
    { id: '', name: 'Все клиенты' }
  )

  const [selectedClientOption, setSelectedClientOption] =
    useState<ClientOption>({
      value: '',
      label: 'Все клиенты',
    })

  const handleClientChange = (selectedOption: ClientOption | null) => {
    if (selectedOption) {
      setSelectedClientOption(selectedOption)
      setClients({
        id: selectedOption.value,
        name: selectedOption.label,
      })
    } else {
      setSelectedClientOption({
        value: '',
        label: 'Все клиенты',
      })
      setClients({
        id: '',
        name: 'Все клиенты',
      })
    }
  }

  useEffect(() => {
    let filtered = [...contracts]

    // CLIENT ID
    if (!!clients.id) {
      filtered = filtered.filter(
        (contract) => contract.client.id === clients.id
      )
    }

    // DATE
    if (startDate && endDate) {
      const start = new Date(startDate)
      start.setHours(0, 0, 0, 0)

      const end = new Date(endDate)
      end.setHours(23, 59, 59, 999)

      filtered = filtered.filter((contract) => {
        const contractDate = new Date(contract.date)
        contractDate.setHours(0, 0, 0, 0)
        return contractDate >= start && contractDate <= end
      })
    }

    // COUNTRY
    if (!!country.id) {
      filtered = filtered.filter(
        (contract) => contract.client.country.iso === country.id
      )
    }

    // STATUS
    if (status.id !== '') {
      filtered = filtered.filter(
        (contract) => Number(contract.active) === status.id
      )
    }

    // Применяем все фильтры одновременно
    setUpdatedContracts(filtered)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clients.id, contracts, country.id, endDate, startDate, status.id])

  // --- ДОБАВЛЕНО: обработка прокрутки для фиксации формы ---
  useEffect(() => {
    const handleScroll = () => {
      const mobilePanelHeight = 45 // Высота мобильной панели
      const scrollThreshold = mobilePanelHeight + 200 // Уменьшаем порог для более плавной работы
      const isMobile = window.innerWidth < 1024

      if (isMobile && window.scrollY > scrollThreshold) {
        setIsFilterFixed(true)
      } else {
        setIsFilterFixed(false)
      }
    }

    // Добавляем throttling для более плавной работы
    let ticking = false
    const throttledHandleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll()
          ticking = false
        })
        ticking = true
      }
    }

    window.addEventListener('scroll', throttledHandleScroll, { passive: true })
    window.addEventListener('resize', throttledHandleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', throttledHandleScroll)
      window.removeEventListener('resize', throttledHandleScroll)
    }
  }, [])

  return (
    <>
      {/* Placeholder для предотвращения скачков при фиксации */}
      {isFilterFixed && <div style={{ height: '80px' }} />}

      <div
        className={classNames(styles.filterForm, styles.filterDocs, 'mb-3', {
          [styles.filterFixed]: isFilterFixed,
        })}
      >
        <div
          className={classNames(
            styles.tableFilterPanel,
            styles.small,
            'row',
            'align-items-end'
          )}
        >
          <div
            className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3"
            ref={redData}
          >
            <div id="docsfilter_date_input_wrapper" className="datePickerInput">
              <input
                className={classNames(styles.calendarInput, styles.date)}
                type="text"
                onClick={handleClick}
                value={
                  startDate && endDate
                    ? `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
                    : 'Выберите диапазон дат'
                }
                readOnly
              />
              {isOpen && (
                <div className={styles.datePickerWrapper}>
                  <DatePicker
                    popperClassName={styles.datePickerWrapper1}
                    calendarClassName={styles.datePickerWrapper1}
                    wrapperClassName={styles.datePickerWrapper1}
                    className={styles.datePickerWrapper1}
                    selected={startDate}
                    onChange={handleChange}
                    startDate={startDate}
                    endDate={endDate}
                    selectsRange
                    monthsShown={2}
                    showPopperArrow={false}
                    locale="ru"
                    inline
                  />
                </div>
              )}
            </div>
          </div>
          <DropDown
            value={country}
            items={COUNTRIES}
            refDropdown={refCountry}
            handleButtonClick={handleButtonClickCountry}
            isSelectMenu={isSelectMenuCountry}
            handleChangeItem={handleSelectChangeCountry}
            isVisibleAddBlock={true}
          />
          <DropDown
            value={status}
            items={STATUSES}
            refDropdown={refStatus}
            handleButtonClick={handleButtonClickStatus}
            isSelectMenu={isSelectMenuStatus}
            handleChangeItem={handleSelectChangeStatus}
          />
          {/* <DropDown
            value={clients}
            items={[{ id: '', name: 'Все клиенты' }, ...getClients]}
            refDropdown={refClients}
            handleButtonClick={handleButtonClickClients}
            isSelectMenu={isSelectMenuClients}
            handleChangeItem={handleSelectChangeClients}
          /> */}

          <div className="col-6 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <Select<ClientOption>
              options={clientOptions}
              value={selectedClientOption}
              onChange={handleClientChange}
              placeholder="Выберите клиента"
              noOptionsMessage={() => 'Клиент не найден'}
              isSearchable
              styles={{
                control: (base, { isFocused }) => ({
                  ...base,
                  minHeight: '38px',
                  height: '38px',
                  boxShadow: isFocused
                    ? 'inset 1px 3px 5px 0px #0000001c;'
                    : 'inset 1px 3px 5px 0px #0000001c;',
                  backgroundColor: '#fff',
                  borderRadius: '5px',
                  fontSize: '16px',
                  fontWeight: 400,
                  color: '#012140',
                  transition: 'all 0.3s ease',
                  border: 'none',
                  outline: 'none',
                  '&:hover': {
                    border: 'none',
                    outline: 'none',
                  },
                  '&:focus': {
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'inset 1px 3px 5px 0px #0000001c;',
                  },
                  '&:active': {
                    border: 'none',
                    outline: 'none',
                  },
                }),
                valueContainer: (base) => ({
                  ...base,
                  height: '40px',
                  padding: '0 15px',
                }),
                input: (base) => ({
                  ...base,
                  margin: '0px',
                  padding: '0px',
                  color: '#012140',
                  '& input': {
                    height: '38px',
                    boxShadow: 'none !important',
                    border: 'none !important',
                  },
                }),
                indicatorsContainer: (base) => ({
                  ...base,
                  height: '38px',
                }),
                dropdownIndicator: (base, { isFocused }) => ({
                  ...base,
                  padding: '4px',
                  color: isFocused ? '#0a4475' : '#012140',
                  transition: 'color 0.3s ease',
                }),
                option: (base, { isFocused, isSelected }) => ({
                  ...base,
                  backgroundColor: isSelected ? '#0a4475' : 'white',
                  color: isSelected
                    ? 'white'
                    : isFocused
                      ? '#b60e27'
                      : '#012140',
                  padding: '8px 15px',
                  fontSize: '16px',
                  borderBottom: '1px solid #e0e0e0',
                  '&:last-child': {
                    borderBottom: 'none',
                  },
                  '&:active': {
                    backgroundColor: '#0a4475',
                    color: 'white',
                  },
                  '&:hover': {
                    color: '#b60e27',
                    backgroundColor: 'white',
                  },
                }),
                menu: (base) => ({
                  ...base,
                  marginTop: '5px',
                  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
                  borderRadius: '5px',
                  overflow: 'hidden',
                }),
                singleValue: (base, { isDisabled }) => ({
                  ...base,
                  color: isDisabled ? '#69697a' : '#012140',
                  transition: 'color 0.3s ease',
                }),
                placeholder: (base, { isDisabled }) => ({
                  ...base,
                  color: isDisabled ? '#69697a' : '#69697a',
                  transition: 'color 0.3s ease',
                }),
              }}
              components={{
                IndicatorSeparator: () => null,
                DropdownIndicator: (props) => (
                  <div
                    {...props.innerProps}
                    style={{
                      padding: '4px',
                      marginRight: '10px',
                    }}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 14 4"
                      fill="currentColor"
                      style={{
                        transition:
                          'transform 0.2s ease, margin-bottom 0.2s ease',
                        transform: props.selectProps.menuIsOpen
                          ? 'rotate(180deg)'
                          : 'rotate(0)',
                        marginBottom: props.selectProps.menuIsOpen
                          ? '-4px'
                          : '0',
                      }}
                    >
                      <path d="M0.636,0.293C0.824,0.105,1.078,0,1.343,0S1.862,0.105,2.05,0.293L7,5.243L11.95,0.293c0.189-0.182,0.441-0.283,0.703-0.281c0.262,0.002,0.513,0.107,0.698,0.293c0.391,0.391,0.391,1.025,0,1.416l-5.657,5.657c-0.188,0.188-0.442,0.293-0.707,0.293s-0.519-0.105-0.707-0.293L0.636,1.709C0.247,1.318,0.247,0.684,0.636,0.293z" />
                    </svg>
                  </div>
                ),
              }}
            />
          </div>
        </div>
      </div>
    </>
  )
}

//@ts-ignore
const Contracts = ({ contracts }: Contract[]) => {
  const dispatch = useDispatch<AppDispatch>()

  // ----------------------------------------------
  const handleDeleteContract = (item: Contract) => {
    dispatch(setCurrentContract(item))
    dispatch(setIsVisibleDeleteModalContract(true))
  }

  const handleEditContract = (item: Contract) => {
    dispatch(setCurrentContract(item))
    dispatch(setIsVisibleModalContract(true))
  }

  const handleEditClient = async (item: Contract) => {
    await dispatch(fetchClient(item.client.id))
    dispatch(setIsVisibleModalClient(true))
  }

  const sortedContracts = [...contracts].sort((a, b) =>
    a.client.name.localeCompare(b.client.name)
  )

  const getAmountPercent = (item: any) => {
    // Проверяем, есть ли необходимые данные
    if (!item.amount || !item.paid_invoices) {
      return false
    }

    // Вычисляем процент оплаченных счетов от общей суммы
    const percentage = (item.paid_invoices / item.amount) * 100

    // Возвращаем true, если оплачено больше 80%
    return percentage > 80
  }
  return (
    <>
      <div
        className={classNames(
          styles.docItem,
          styles.small2,
          'd-none d-lg-block pl-2 pr-2',
          'mt-4 mb-2',
          'mb-3'
        )}
      >
        <div className="row">
          <div className="col-lg-1 col-xl-1">
            <span className={classNames(styles.colorGray)}>Номер</span>
          </div>
          <div className="col-lg-4 col-xl-4">
            <span className={classNames(styles.colorGray)}>Клиент</span>
          </div>
          <div className="col-lg-2 col-xl-2">
            <span className={classNames(styles.colorGray)}>Дата</span>
          </div>
          <div className="col-lg-2 col-xl-2">
            <span className={classNames(styles.colorGray)}>Действует до</span>
          </div>
          <div className="col-lg-1 col-xl-1">
            <span className={classNames(styles.colorGray)}>Статус</span>
          </div>
          <div className="col-lg-2 col-xl-2"></div>
        </div>
      </div>

      {sortedContracts?.map((item: Contract) => {
        return (
          <div
            key={`${item.id}-${item.number}-${item.date}`}
            className={classNames(
              styles.bgWhite,
              styles.border10,
              styles.bxShadow,
              styles.small2,
              styles.docItem,
              'pl-2',
              'pr-2',
              'mb-3'
            )}
          >
            <div className={classNames(styles.row, 'row')}>
              <div
                className={classNames(
                  styles.colorGray,
                  'order-4 col-5 order-sm-1 col-sm-3 order-md-1 col-md-3 order-lg-1 col-lg-1 col-xl-1 pt-1 pb-1'
                )}
              >
                {item.number}
              </div>

              <div
                className={classNames(
                  styles.docClient,
                  'order-1 col-6 order-sm-2 col-sm-9 order-md-2 col-md-7 order-lg-2 col-lg-4 col-xl-4 pt-1 pb-1'
                )}
                onClick={() => handleEditClient(item)}
              >
                <a className={styles.client}>
                  <div className={styles.clientLogo}>
                    <img
                      className={
                        !!item?.client?.logo?.original ? '' : styles.opacity02
                      }
                      src={
                        item?.client?.logo?.original ||
                        'img/clients/icon-flag.svg'
                      }
                    />
                  </div>
                  <div className="name ellipsis-2">
                    <b>{item.client.name}</b>
                  </div>
                </a>
              </div>
              <div
                className={classNames(
                  styles.colorGray,
                  'order-6 col-3 order-sm-5 col-sm-2 order-md-6 col-md-2 order-lg-4 col-lg-2 col-xl-2 pt-1 pb-1'
                )}
              >
                {formatDate(item.date)}
              </div>
              <div
                className={classNames(
                  styles.colorGray,
                  !item.prolongation &&
                    isLessThanAMonth(item.expires_at) &&
                    styles.colorRed,
                  'order-6 col-3 order-sm-5 col-sm-2 order-md-6 col-md-2 order-lg-4 col-lg-2 col-xl-2 pt-1 pb-1'
                )}
              >
                до {formatDate(item.expires_at)}
                {item.prolongation && (
                  <div className={classNames(styles.small3, styles.colorBlue)}>Автопродление</div>
                )}
              </div>
              <div
                className={classNames(
                  styles.docStatus,
                  'order-2 col-3 order-sm-3 col-sm-3 order-md-4 col-md-3 order-lg-5 col-lg-1 col-xl-1 pt-1 pb-1'
                )}
              >
                {item.active ? (
                  <>
                    <i
                      className={`${styles.icon} ${styles.iconVerified2} ${styles.icon16}`}
                    />{' '}
                    <span>Активен</span>
                  </>
                ) : (
                  <span>Закрыт</span>
                )}
                <br />
                {getAmountPercent(item) && (
                  <span
                    className={classNames(
                      styles.colorRed,
                      styles.small3,
                      styles.hintTrigger
                    )}
                    onMouseEnter={(e) => {
                      const hint = e.currentTarget.querySelector(
                        `.${styles.hint}`
                      ) as HTMLElement
                      if (hint) {
                        const rect = e.currentTarget.getBoundingClientRect()
                        hint.style.left = rect.left + 20 + 'px'
                        hint.style.top = rect.top + 15 + 'px'
                        hint.style.display = 'block'
                      }
                    }}
                    onMouseLeave={(e) => {
                      const hint = e.currentTarget.querySelector(
                        `.${styles.hint}`
                      ) as HTMLElement
                      if (hint) {
                        hint.style.display = 'none'
                      }
                    }}
                  >
                    <i
                      className={classNames(
                        styles.icon,
                        styles.iconAlarm,
                        styles.iconRed,
                        styles.icon16
                      )}
                    ></i>{' '}
                    Сумма
                    <span className={styles.hint}>
                      Близок предел
                      <br />
                      {getAmount(item?.paid_invoices)} из{' '}
                      {getAmount(item?.amount)}{' '}
                      {getItemCurrency(item?.currency)}
                      <br />
                      Осталось:{' '}
                      {getAmount(
                        getContractRemainingAmount(
                          item?.amount,
                          item?.paid_invoices
                        )
                      )}{' '}
                      {getItemCurrency(item?.currency)}
                    </span>
                  </span>
                )}
              </div>
              <div
                className="doc-buttons order-3 col-3 order-sm-6 col-sm-5 order-md-3 col-md-2 order-lg-6 col-lg-2 col-xl-2 pt-1 pb-1"
                style={{ textAlign: 'right' }}
              >
                <EditButton onClick={() => handleEditContract(item)} />
                <DeleteButton onClick={() => handleDeleteContract(item)} />
              </div>
            </div>
          </div>
        )
      })}
    </>
  )
}

function DocumentsContracts() {
  const dispatch = useDispatch<AppDispatch>()

  const [updatedContracts, setUpdatedContracts] = useState<[] | Contract[]>([])

  const { contracts } = useSelector(contractsSelector)

  useEffect(() => {
    dispatch(fetchContracts())
    dispatch(fetchClients())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="tabs-content">
      <div className="row">
        <div className="col-12 offset-md-1 col-md-10 offset-lg-0 col-lg-12  offset-xl-1 col-xl-10">
          <div className="tab-content" data-content="tab_docs_1">
            <Filter setUpdatedContracts={setUpdatedContracts} />

            {!!updatedContracts.length ? (
              //@ts-ignore
              <Contracts contracts={updatedContracts} />
            ) : (
              <div
                style={{ textAlign: 'center' }}
                className="pt-5 pb-5 pl-5 pr-5 bg-white border-10"
              >
                <p>
                  <i className="icon icon-70 opacity-03 icon-reports"></i>
                </p>
                <div className="font-big color-gray">
                  Таких документов за выбранный период пока нет
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DocumentsContracts
